// test2284
(2284 && 0);
